import type { ReactNode } from 'react';
import { X } from 'lucide-react';

export const SheetSection = ({ title, children }: { title: string; children: ReactNode }) => (
  <section className="border-t border-domino-cardBorder pt-4">
    <h3 className="text-sm font-semibold text-domino-ink">{title}</h3>
    <div className="mt-2 space-y-2">{children}</div>
  </section>
);

/** One line of the sheet: its text, an optional justification, a delete cross. */
export const SheetRow = ({ children, why, showWhy, onRemove, removeLabel }: {
  children: ReactNode;
  why?: ReactNode;
  showWhy: boolean;
  onRemove?: () => void;
  removeLabel: string;
}) => (
  <div className="group flex items-start gap-2 text-sm">
    <div className="min-w-0 flex-1">
      <div className="text-domino-ink">{children}</div>
      {showWhy && why ? <div className="mt-0.5 text-domino-inkSoft">{why}</div> : null}
    </div>
    {onRemove && (
      <button
        type="button"
        aria-label={removeLabel}
        title="Supprimer"
        className="mt-0.5 rounded p-0.5 text-domino-inkSoft opacity-0 transition-opacity duration-150 hover:bg-domino-muted focus-visible:opacity-100 group-hover:opacity-100"
        onClick={onRemove}
      >
        <X className="h-3.5 w-3.5" aria-hidden="true" />
      </button>
    )}
  </div>
);
